import React from 'react';

const LikeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33.566" height="33.566" viewBox="0 0 33.566 33.566">
      <g>
        <path fill={'currentColor'} d="M0 22.692V8.483a2.827 2.827 0 0 1 .476-1.567l3.818-5.678A3.021 3.021 0 0 1 7.664.161 3.047 3.047 0 0 1 9.65 3.532L8.923 8.1a1.4 1.4 0 0 0 .294 1.1 1.3 1.3 0 0 0 .965.434h5.748a3.132 3.132 0 0 1 2.615 1.231 2.946 2.946 0 0 1 .28 2.727l-3.44 10.471a4.493 4.493 0 0 1-4.2 3.147H5.734a4.559 4.559 0 0 1-2.853-.923L1.091 24.9A2.776 2.776 0 0 1 0 22.692z" transform="translate(11.734 3.168)"/>
        <path fill={'currentColor'} d="M4.49 0H3.049C.881 0 0 .839 0 2.909v14.07c0 2.07.881 2.909 3.049 2.909H4.49c2.168 0 3.049-.839 3.049-2.909V2.909C7.538.839 6.657 0 4.49 0z" transform="translate(2.797 8.923)"/>
      </g>
    </svg>
  );
};

export default LikeIcon;
